export const DIRTY = 'SAVE_STATE.DIRTY';
export const SAVED = 'SAVE_STATE.SAVED';
export const SAVE_REQUEST = 'SAVE_STATE.SAVE_REQUEST';


// WEBPACK FOOTER //
// ./src/constants/SaveState.ts